var React = require('react');

function IconValidate (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"none","stroke":"#00d664","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":"56.8889","d":"M995.556 512c0 267.060-216.495 483.556-483.556 483.556s-483.556-216.495-483.556-483.556c0-267.060 216.495-483.556 483.556-483.556s483.556 216.495 483.556 483.556z","key":1}),React.createElement("path",{"fill":"none","stroke":"#00d664","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":"56.8889","d":"M254.104 505.553l196.646 167.633 319.147-322.37","key":2})]);
}

IconValidate.defaultProps = {"version":"1.1","width":"1024","height":"1024","viewBox":"0 0 1024 1024"};

module.exports = IconValidate;

IconValidate.default = IconValidate;
